import { BillingCity } from '@billing/entities/billing.payload';
import { Address } from '@app/modules/core/interfaces/address';

const NORMALIZE_FORM = 'NFD';

function normalize(name: string): string {
  return name ? name.normalize(NORMALIZE_FORM).replace(/[\u0300-\u036f]/g, '').replace(/-/g, ' ') : '';
}

export function findCityByName(address: Address, cities: BillingCity[]): string {
  const city = address.city;
  const defaultCityAddress = city ? city.city : address.address ?
    address.address.split('[').pop().split(']')[0] : null;
  if (defaultCityAddress && cities?.length > 0) {
    const fullCity = cities.find(cityData => {
      const cityItemName = normalize(cityData.description);
      const defaultCityName = normalize(defaultCityAddress);
      return defaultCityName.toUpperCase().includes(cityItemName.toUpperCase());
    });
    return fullCity ? fullCity.code : '';
  } else {
    return '';
  }
}
